// extracted by mini-css-extract-plugin
var _1 = "PurchaseManage__bottom--KBNej";
var _2 = "PurchaseManage__bottomContent--yb9xg";
var _3 = "PurchaseManage__editLimitButton--pSZ4P SchoolGeneral__button--ZIm36";
var _4 = "PurchaseManage__helpLink--S2Nz8";
var _5 = "PurchaseManage__helpText--Rp2us";
var _6 = "PurchaseManage__info--MXQJP";
var _7 = "PurchaseManage__label--MTi6n";
var _8 = "PurchaseManage__limitWithButton--OMspu";
var _9 = "PurchaseManage__main--Kg0ov";
var _a = "PurchaseManage__noEditLimitButton--dRlbu";
var _b = "PurchaseManage__rostering--pRtN8";
var _c = "PurchaseManage__rosteringBody--e5OY0";
var _d = "PurchaseManage__rosteringContent--UjMwy";
var _e = "PurchaseManage__rosteringDescription--Bmx6E";
var _f = "PurchaseManage__rosteringHeader--Bi3u4";
var _10 = "PurchaseManage__section--jnvwA";
var _11 = "PurchaseManage__sectionItem--aSH5b";
var _12 = "PurchaseManage__sectionTitle--lQJ0c";
var _13 = "PurchaseManage__title--wcbbg";
var _14 = "PurchaseManage__upper--KkTHE";
export { _1 as "bottom", _2 as "bottomContent", _3 as "editLimitButton", _4 as "helpLink", _5 as "helpText", _6 as "info", _7 as "label", _8 as "limitWithButton", _9 as "main", _a as "noEditLimitButton", _b as "rostering", _c as "rosteringBody", _d as "rosteringContent", _e as "rosteringDescription", _f as "rosteringHeader", _10 as "section", _11 as "sectionItem", _12 as "sectionTitle", _13 as "title", _14 as "upper" }
